import { render } from "./ActionSendWhatsapp.vue?vue&type=template&id=24b6d4a1"
import script from "./ActionSendWhatsapp.vue?vue&type=script&lang=ts"
export * from "./ActionSendWhatsapp.vue?vue&type=script&lang=ts"
script.render = render

export default script